import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";

import {
  Grid2,
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
import { getpromptByID } from "../../actions/promptStoreAction";
import AiModelSelector from "./AiModelSelector";
import CheckIcon from "@mui/icons-material/Check";
import { generateAIOutput } from "./AiGenerator";

const Template = () => {
  const { workspaceId, id } = useParams();
  const dispatch = useDispatch();

  const prompt = useSelector((state) => state.prompts.selectedPrompt);
  const [variables, setVariables] = useState({});
  const [error, setError] = useState("");
  const [generatedPrompt, setGeneratedPrompt] = useState("");
  const [aiOutput, setAiOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const currentWorkspace = useSelector(
    (state) => state.workspace.workspaceInfo
  );

  const [model, setSelectedModel] = useState(null);

  console.log("Selected AI Model:", model);

  const [formData, setFormData] = useState({
    // promptName: "",
    createdBy: "",
    systemInstruction: "",
    variables: [],
  });

  useEffect(() => {
    const loadData = async () => {
      if (id) {
        await dispatch(getpromptByID(workspaceId, id));
      } else {
      }
    };
    loadData();
  }, [workspaceId, id, dispatch]);

  useEffect(() => {
    if (prompt) {
      setFormData({
        promptName: prompt.promptName || "",
        promptTemplate: prompt.promptTemplate || "",
        systemInstruction: prompt.systemInstruction || "",
        variables: prompt.variables || [],
      });
    }
  }, [prompt]);

  useEffect(() => {
    if (!formData.promptTemplate) return;

    let tempPrompt = formData.promptTemplate;
    let systemInstruction = formData.systemInstruction;

    Object.keys(variables).forEach((key) => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g");
      tempPrompt = tempPrompt.replace(regex, variables[key] || `{{${key}}}`);
    });

    tempPrompt = systemInstruction + ". " +tempPrompt;

    setGeneratedPrompt(tempPrompt);
  }, [variables, formData.promptTemplate]);

  // Handle form input
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleInputVariablesChange = (key, value) => {
    setVariables((prev) => ({ ...prev, [key]: value }));
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated form data:", formData);
  };

  const handleGenerate = async () => {
    if (model === null) {
      setError("Select AI model");
      return;
    }

    if (!formData.promptTemplate) {
      setError("Prompt template is empty!");
      return;
    }

    const emptyVars = formData.variables.filter(
      (v) => !variables[v] || variables[v].trim() === ""
    );

    if (emptyVars.length > 0) {
      setError(`Please fill all variables: ${emptyVars.join(", ")}`);
      return;
    }

    // Clear previous errors
    setError("");
    setAiOutput("");
    setLoading(true);

    // Replace variables in the template
    let generatedPrompt = formData.promptTemplate;
    Object.keys(variables).forEach((key) => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g");
      generatedPrompt = generatedPrompt.replace(regex, variables[key]);
    });
    generatedPrompt = formData.systemInstruction + ". " + generatedPrompt;
    console.log("Generated Prompt:", generatedPrompt);

     console.log(generatedPrompt);
        const result = await generateAIOutput(model, generatedPrompt, (streamChunk) => {
          // setOutput(streamChunk); // updates live
           setAiOutput(streamChunk);
      });
    

    //ai generator

    // let selectedModel;
    // let endpoint;

    // switch (model?.model) {
    //   case "deepseek":
    //     selectedModel = "deepseek-chat";
    //     endpoint = process.env.REACT_APP_DEEPSEEK_ENDPOINT;
    //     break;
    //   case "qwen":
    //     selectedModel = "Qwen/Qwen2.5-VL-72B-Instruct-AWQ";
    //     endpoint = process.env.REACT_APP_QWEN_ENDPOINT;
    //     break;
    //   case "chatgpt":
    //     selectedModel = "gpt-4o";
    //     endpoint = process.env.REACT_APP_CHATGPT_ENDPOINT;
    //     break;
    //   case "gemini":
    //     selectedModel = "gemini-2.5-flash";
    //     endpoint = process.env.REACT_APP_GEMINI_ENDPOINT;
    //     break;
    //   default:
    //     return;
    // }

    // const requestBody =
    //   model?.model === "chatgpt"
    //     ? {
    //         model: selectedModel,
    //         input: [{ role: "user", content: generatedPrompt }],
    //         stream: true,
    //       }
    //     : model?.model === "gemini"
    //     ? {
    //         model: selectedModel,
    //         contents: [
    //           {
    //             role: "user",
    //             parts: [{ text: generatedPrompt }],
    //           },
    //         ],
    //       }
    //     : {
    //         model: selectedModel,
    //         messages: [{ role: "user", content: generatedPrompt }],
    //         stream: true,
    //       };

    // const headers = {
    //   "Content-Type": "application/json",
    //   ...(model?.model === "gemini"
    //     ? { "x-goog-api-key": model?.apiKey }
    //     : { Authorization: `Bearer ${model?.apiKey}` }),
    // };
    // let firstChunkReceived = false;

    // try {
    //   const response = await fetch(endpoint, {
    //     method: "POST",
    //     headers,
    //     body: JSON.stringify(requestBody),
    //   });

    //   console.log(response);

    //   if (!response.ok)
    //     throw new Error(`HTTP error! Status: ${response.status}`);

    //   const reader = response.body.getReader();
    //   const decoder = new TextDecoder();
    //   console.log(decoder);
    //   let accumulatedText = "";

    //   while (true) {
    //     const { done, value } = await reader.read();
    //     if (done) break;

    //     const chunk = decoder.decode(value, { stream: true });
    //     const lines = chunk.split("\n").filter((line) => line.trim() !== "");

    //     for (let line of lines) {
    //       line = line.trim();
    //       if (!line.startsWith("data: ")) continue;

    //       const data = line.replace("data: ", "").trim();
    //       if (data === "[DONE]") break;

    //       try {
    //         const parsed = JSON.parse(data);

    //         // Gemini chunk
    //         const textChunk =
    //           parsed.candidates?.[0]?.content?.parts
    //             ?.map((p) => p.text)
    //             .join("") ||
    //           // OpenAI-style chunk (Deepskeek, chatgpt, qwen)
    //           parsed.choices?.[0]?.delta?.content ||
    //           "";

    //         if (textChunk) {
    //           accumulatedText += textChunk;
    //           setAiOutput(accumulatedText);

    //           if (!firstChunkReceived) {
    //             setLoading(false);
    //             firstChunkReceived = true;
    //           }
    //         }
    //       } catch (e) {
    //         console.error("Error parsing JSON:", e, "line:", line);
    //       }
    //     }
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    //   setError("Failed to generate content");
    // } finally {
    //   if (!firstChunkReceived) setLoading(false);
    //   setLoading(false);
    // }
  };

  return (
    <div>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid2 container spacing={2}  alignItems="center">
            <Grid2 size={{ xs: 12, md: 8 }}>
              <Typography variant="h2">
                Template : {formData.promptName ?? ""}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <AiModelSelector selectedModel={model} onModelSelect={(modelData) => setSelectedModel(modelData)}/>
            </Grid2>
          </Grid2>

          {/* <TextField
          name="promptName"
          label="Prompt Name"
          value={formData.promptName ?? ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
          disabled
        /> */}
          {/* <TextField
          name="System Instruction"
          label="Prompt Instruction"
          value={formData.systemInstruction ?? ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          rows={2}
        /> */}
          {/* <TextField
          name="promptTemplate"
          label="Prompt Template"
          value={formData.promptTemplate ?? ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          rows={4}
        /> */}

          {generatedPrompt && (
            <Box
              mt={3}
              p={2}
              border="1px solid #ccc"
              borderRadius={2}
              bgcolor="#f9f9f9"
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Prompt Preview:
              </Typography>
              <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                {generatedPrompt}
              </Typography>
            </Box>
          )}

          {/* {formData.variables && (
          <div>
            <h2>Fill variables</h2>
            {formData.variables?.map((v) => (
              <div key={v} className="mb-3">
                <label className="block text-sm font-medium mb-1">{v}</label>
                <input
                  type="text"
                  value={variables[v] || ""}
                  onChange={(e) =>
                    handleInputVariablesChange(v, e.target.value)
                  }
                  className="w-full border px-3 py-2 rounded-md focus:ring-2 focus:ring-indigo-400"
                />
              </div>
            ))}
          </div>
        )} */}

          {formData.variables && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Fill variables
              </Typography>

              {formData.variables?.map((v) => (
                <Box key={v} sx={{ mb: 3 }}>
                  <TextField
                    fullWidth
                    label={v}
                    value={variables[v] || ""}
                    onChange={(e) =>
                      handleInputVariablesChange(v, e.target.value)
                    }
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiInputLabel-root": { fontSize: 14 },
                      "& .MuiInputBase-input": { fontSize: 14 },
                    }}
                  />
                </Box>
              ))}
            </Box>
          )}

          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <button
            type="button"
            onClick={handleGenerate}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
          >
            Generate Content
          </button>
        </form>

        <Box
          mt={3}
          p={2}
          border="1px solid #ccc"
          borderRadius={2}
          bgcolor="#f3f3f3"
        >
          <Typography variant="subtitle1" fontWeight="bold">
            AI Output:
          </Typography>
          {loading && (
            <div className="flex space-x-1 mt-2">
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:0ms]"></span>
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:150ms]"></span>
              <span className="w-1 h-1 bg-gray-500 rounded-full animate-bounce [animation-delay:300ms]"></span>
            </div>
          )}

          <Typography
            variant="body1"
            sx={{ whiteSpace: "pre-wrap", minHeight: "100px" }}
          >
            {aiOutput}
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default Template;
